import { render, staticRenderFns } from "./Vertragszustimmung.vue?vue&type=template&id=4fbef196"
import script from "./Vertragszustimmung.vue?vue&type=script&lang=js"
export * from "./Vertragszustimmung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports